import { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';

const navItems = [
  { label: '首页', path: '/' },
  {
    label: '分类',
    path: '#',
    children: [
      { label: '电影', path: '/category/dianying' },
      { label: '电视剧', path: '/category/dianshiju' },
      { label: '纪录片', path: '/category/jilupian' },
      { label: '动漫', path: '/category/dongman' },
      { label: '综艺', path: '/category/zongyi' },
    ],
  },
  { label: '关于我们', path: '/about' },
];

export default function Navbar() {
  const [scrolled, setScrolled] = useState(false);
  const [mobileOpen, setMobileOpen] = useState(false);
  const [dropdownOpen, setDropdownOpen] = useState(false);
  const location = useLocation();

  useEffect(() => {
    const handleScroll = () => {
      setScrolled(window.scrollY > 20);
    };
    window.addEventListener('scroll', handleScroll);
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  useEffect(() => {
    setMobileOpen(false);
    setDropdownOpen(false);
  }, [location.pathname]);

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 ${
        scrolled ? 'bg-background-50/95 backdrop-blur-md border-b border-background-200/70' : 'bg-transparent'
      }`}
    >
      <nav className="max-w-7xl mx-auto px-4 md:px-6 flex items-center justify-between h-16">
        <Link to="/" className="flex items-center gap-2">
          <i className="ri-movie-2-line text-primary-500 text-2xl w-8 h-8 flex items-center justify-center"></i>
          <span className="font-heading text-lg font-bold text-foreground-900 whitespace-nowrap">
            免费看片推荐
          </span>
        </Link>

        <div className="hidden md:flex items-center gap-8">
          {navItems.map((item) => {
            if (item.children) {
              return (
                <div
                  key={item.label}
                  className="relative"
                  onMouseEnter={() => setDropdownOpen(true)}
                  onMouseLeave={() => setDropdownOpen(false)}
                >
                  <button className="flex items-center gap-1 text-sm text-foreground-700 hover:text-primary-500 transition-colors whitespace-nowrap cursor-pointer">
                    {item.label}
                    <i className="ri-arrow-down-s-line w-4 h-4 flex items-center justify-center"></i>
                  </button>
                  {dropdownOpen && (
                    <div className="absolute top-full left-0 mt-2 bg-background-50 border border-background-200/70 rounded-lg py-2 w-36">
                      {item.children.map((child) => (
                        <Link
                          key={child.path}
                          to={child.path}
                          className="block px-4 py-2 text-sm text-foreground-700 hover:bg-background-100 hover:text-primary-500 transition-colors whitespace-nowrap"
                        >
                          {child.label}
                        </Link>
                      ))}
                    </div>
                  )}
                </div>
              );
            }
            return (
              <Link
                key={item.path}
                to={item.path}
                className={`text-sm transition-colors whitespace-nowrap ${
                  location.pathname === item.path
                    ? 'text-primary-500 font-medium'
                    : 'text-foreground-700 hover:text-primary-500'
                }`}
              >
                {item.label}
              </Link>
            );
          })}
        </div>

        <button
          className="md:hidden w-10 h-10 flex items-center justify-center cursor-pointer"
          onClick={() => setMobileOpen(!mobileOpen)}
          aria-label="菜单"
        >
          <i className={`text-xl ${mobileOpen ? 'ri-close-line' : 'ri-menu-line'} text-foreground-900`}></i>
        </button>
      </nav>

      {mobileOpen && (
        <div className="md:hidden bg-background-50 border-t border-background-200/70 px-4 py-4">
          {navItems.map((item) => {
            if (item.children) {
              return (
                <div key={item.label} className="mb-2">
                  <p className="text-sm font-medium text-foreground-900 py-2">{item.label}</p>
                  <div className="pl-4 space-y-1">
                    {item.children.map((child) => (
                      <Link
                        key={child.path}
                        to={child.path}
                        className="block text-sm text-foreground-600 hover:text-primary-500 py-1.5 transition-colors"
                      >
                        {child.label}
                      </Link>
                    ))}
                  </div>
                </div>
              );
            }
            return (
              <Link
                key={item.path}
                to={item.path}
                className="block text-sm text-foreground-700 hover:text-primary-500 py-2 transition-colors"
              >
                {item.label}
              </Link>
            );
          })}
        </div>
      )}
    </header>
  );
}